import { Component, h } from 'preact'
import ButtonControl from '../../button-control'
import Icon from '../../assets'
import SelectColumnsModal from './SelectColumnsModal'
import { Model } from '../../table/types'

type Props = {
  selectedColumns: Model[],
  defaultColumns: Model[],
  applySelectedColumns: (columns: Model[]) => void
}

type State = {
  columns: Model[],
  showSelectColumnsModal: boolean
}

export function copyColumns (columns: Model[]): Model[] {
  return columns.map((column: Model): Model[] => {
    return {...column} as Model[]
  })
}

class OverviewColumns extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      columns: copyColumns(props.selectedColumns),
      showSelectColumnsModal: false
    }

    this.toggleColumn = this.toggleColumn.bind(this)
    this.onApply = this.onApply.bind(this)
    this.onClose = this.onClose.bind(this)
    this.onResetToDefault = this.onResetToDefault.bind(this)
  }

  onApply () {
    this.props.applySelectedColumns(this.state.columns)
    this.setState({ showSelectColumnsModal: false })
  }

  onClose () {
    this.setState({
      showSelectColumnsModal: false,
      columns: copyColumns(this.props.selectedColumns)
    })
  }

  onResetToDefault () {
    this.setState({ columns: copyColumns(this.props.defaultColumns) })
  }

  toggleColumn (accessor: string, checked: boolean) {
    const { columns } = this.state
    let changedColumn = columns.find((column: Model) => column.accessor === accessor)
    if (changedColumn) changedColumn.isHidden = !checked
    columns.map((column: any) => column.accessor === accessor ? changedColumn : column)
    this.setState({ columns })
  }

  render ({ selectedColumns, defaultColumns }: Props, { columns, showSelectColumnsModal }: State) {
    return (
      <div class='overview__columns-container'>
        <ButtonControl
          newStyle
          title={<div><Icon icon='column' />Columns</div>}
          size='medium'
          class='overview__columns'
          onClick={() => this.setState({ showSelectColumnsModal: true })}
        />
        <SelectColumnsModal
          columns={columns}
          showModal={showSelectColumnsModal}
          onApply={this.onApply}
          onClose={this.onClose}
          onResetToDefault={this.onResetToDefault}
          toggleColumn={this.toggleColumn}
        />
      </div>
    )
  }
}

export default OverviewColumns
